import * as ReselectModule from "reselect";
import { IClientRightUserListState } from ".";
import { IApplicationState } from "..";

export const selectClientRightUserList: ReselectModule.Selector<
  IApplicationState,
  IClientRightUserListState
> = (state) => state.clientRightUserList;
